import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';

import TextField from '@mui/material/TextField';
import DialogContent from '@mui/material/DialogContent';

const styles = theme => ({
    formControl: {
        width: '100%'
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});


class DemanderRetourGeneralTousMagasinsContent extends React.Component {

    state = {
        commentaire: "",
        codeArticle: ''
    };

    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action} = this.props;
        
        if (stringHelper.isNullOrWhitespace(newState.codeArticle)) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.commentaire)) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.CodeArticle,
                type: ReclamationActionDetailType.Texte,
                libelle: "Code article",
                position: 0,
                valeurString: newState.codeArticle
            }],
            reponseAttendue: false
        };
    
        {
            let detail = {
                code: ReclamationActionDetailCodes.Memo,
                type: ReclamationActionDetailType.Texte,
                libelle: "Mémo :",
                position: actionData.details.length,
                valeurString: `Suite au problème suivant : ${newState.commentaire}.\nTous les articles ${newState.codeArticle} doivent être retournés depuis les magasins au Monné pour analyse qualité.\nMerci d'organiser au mieux ce retour.`
            };

            actionData.details.push(detail);
        }

        return actionData;
    }

    handleChange = (event) => {

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { commentaire, codeArticle } = this.state;

        return (
            <DialogContent>
                <TextField className={classes.formControl}
                    required
                    id="codeArticle"
                    name="codeArticle"
                    label="Code article"
                    placeholder="Code article"
                    multiline
                    margin="normal"
                    value={codeArticle}
                    onChange={this.handleChange}
                />

                
                <TextField className={classes.formControl}
                    id="commentaire"
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={this.handleChange}
                />
            </DialogContent>
        );
    }
}

DemanderRetourGeneralTousMagasinsContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(DemanderRetourGeneralTousMagasinsContent);